export const SET_CURRENT_TAB = 'adminOrder/SET_CURRENT_TAB';
export const GET_ORDERS = 'adminOrder/GET_ORDERS';
export const UPDATE_ORDER = 'adminOrder/UPDATE_ORDER';
export const SET_ORDERS_FROM = 'adminOrder/SET_ORDERS_FROM';
